import __request__ from "routing/request";
export function update(body, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.securityapp/tour/config", body, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function read(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp/tour/config", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
